<template>
    <NuxtImg
      v-if="src"
      :src="toImgixPath(src)"
      provider="imgix"
      format="webp"
      fit="crop"
      class="w-full"
      :modifiers="{ 
        ar: '1:1',
        auto: 'format,compress',        
        crop: 'faces,edges'
      }"/>
    
  </template>
  
    
    <script setup>
    const {toImgixPath} = useImageUtils();
    // Props
    const props = defineProps({
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: 'Image'
      },
      width: {
        type: [String, Number],
        default: 679
      },
      height: {
        type: [String, Number],
        default: 679
      },
      sizes: {
        type: String,
        default: 'sm:100vw md:480px lg:720px xl:960px'
      }
    });
    
    
    </script>
    
    <style scoped>
   
    </style>